import type { SupportedUserLanguage } from './types'

export const SYSTEM_USER_NAME_MAP: Record<string, Record<SupportedUserLanguage, string>> = {
  'super admin': {
    'zh-CN': '超级管理员',
    'en-US': 'Super Admin',
  },
  superadmin: {
    'zh-CN': '超级管理员',
    'en-US': 'Super Admin',
  },
  admin: {
    'zh-CN': '管理员',
    'en-US': 'Admin',
  },
}

export const FALLBACK_USER_NAME: Record<SupportedUserLanguage, string> = {
  'zh-CN': '访客',
  'en-US': 'Guest',
}
